import type { Entity } from "./types";

export class World {
  private nextEntityId = 1;
  private entities = new Set<number>();

  createEntity(): Entity {
    const id = this.nextEntityId++;
    this.entities.add(id);
    return { id };
  }

  destroyEntity(e: Entity): void {
    this.entities.delete(e.id);
  }

  hasEntity(e: Entity): boolean {
    return this.entities.has(e.id);
  }
}